export default "__VITE_ASSET___HNonsK___"